import { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faComments,
	faPaperPlane,
	faCreditCard,
	faCopy,
} from "@fortawesome/free-regular-svg-icons";
import {
	faWallet,
	faAngleDown,
	faArrowUpRightFromSquare,
	faXmark,
	faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import { faBitcoin } from "@fortawesome/free-brands-svg-icons";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Drawer from "@mui/material/Drawer";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import QRCode from "react-qr-code";
import AlertMessage from "../Alert/Alert";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";
import axios from "axios";
import "./wrapper.css";

const Wrapper = () => {
	const { logout } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();
	const [anchorEl, setAnchorEl] = useState(null);
	const [anchorEl2, setAnchorEl2] = useState(null);
	const [drawerElOpen, setDrawerElOpen] = useState(false);
	const [activeMethod, setActiveMethod] = useState("crypto");
	const open = Boolean(anchorEl);
	const open2 = Boolean(anchorEl2);
	const [wallets, setWallets] = useState([]);
	const [payentInputs, setPaymentInputs] = useState({
		send: "",
		amount: "",
		currentAmount: "",
	});
	const [qrData, setQrData] = useState("");
	const [alertParams, setAlertParams] = useState({
		open: false,
		message: "",
		type: "",
	});
	const [user, setUser] = useState({});
	const handleAlertClose = () => {
		setAlertParams({ ...alertParams, open: false });
	};
	const fetchUserData = async () => {
		try {
			const user = auth.currentUser;

			if (!user) {
				console.error("Пользователь не авторизован");
				return;
			}

			// Ссылка на документ пользователя в Firestore
			const userDocRef = doc(db, "users", user.uid);

			// Получение данных
			const userDoc = await getDoc(userDocRef);

			if (userDoc.exists()) {
				console.log("Данные пользователя:", userDoc.data());
				setUser(userDoc.data());
				return userDoc.data(); // Возвращаем данные пользователя
			} else {
				console.log("Данные пользователя не найдены");
			}
		} catch (error) {
			console.error("Ошибка получения данных:", error);
		}
	};

	useEffect(() => {
		fetchUserData();
	}, []);

	const getCryptoRates = async (crypto) => {
		try {
			const response = await fetch(
				`https://api.coingecko.com/api/v3/simple/price?ids=${crypto}&vs_currencies=usd`
			);

			if (!response.ok) {
				throw new Error(`Ошибка HTTP: ${response.status}`);
			}

			const data = await response.json();
			setPaymentInputs({
				...payentInputs,
				currentAmount: Object.values(data)[0].usd,
			});
		} catch (error) {
			console.error("Ошибка при получении курсов криптовалют:", error);
			return null;
		}
	};
	const getCardRates = async () => {
		try {
			const response = await fetch(
				"https://v6.exchangerate-api.com/v6/03390dc7c1a292a00f9bbf18/latest/USD" // Замените YOUR_API_KEY на ваш API-ключ
			);

			if (!response.ok) {
				throw new Error(`Ошибка HTTP: ${response.status}`);
			}

			const data = await response.json();
			setPaymentInputs({
				...payentInputs,
				currentAmount: data.conversion_rates.RUB,
			});
		} catch (error) {
			console.error("Ошибка при получении курса валют:", error);
			return null;
		}
	};

	useEffect(() => {
		axios
			.get("http://localhost:3001/wallets")
			.then((response) => setWallets(response.data))
			.catch((error) => console.error("Ошибка загрузки JSON:", error));
	}, []);

	useEffect(() => {
		if (activeMethod === "crypto" && payentInputs.send) {
			const crypto = wallets[0].wallets.find(
				(wallet) => wallet.wallet === payentInputs.send
			)?.title;
			getCryptoRates(crypto);
		} else if (activeMethod === "card" && payentInputs.send) {
			getCardRates();
		}
	}, [payentInputs.send]);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClick2 = (event) => {
		setAnchorEl2(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
		setDrawerElOpen(false);
		setAnchorEl2(null);
	};
	const handleDrawerOpen = () => {
		handleClose();
		setDrawerElOpen(true);
	};
	const handleLogout = async () => {
		try {
			await logout();
			navigate("/login"); // Перенаправление на страницу входа после выхода
		} catch (error) {
			console.error("Ошибка при выходе:", error);
		}
	};
	const handleChange = (event) => {
		const value = event.target.value;
		setPaymentInputs({
			...payentInputs,
			[event.target.name]:
				event.target.name === "amount"
					? /^[0-9]*\.?[0-9]*$/.test(value)
						? value
						: ""
					: value,
		});
	};
	const generateQRData = (crypto, amount, wallet) => {
		if (!crypto || !amount || !wallet) return "";

		if (crypto === "bitcoin") {
			return `bitcoin:${wallet}?amount=${amount}`;
		} else if (crypto === "ethereum") {
			return `ethereum:${wallet}?value=${amount}`;
		} else {
			return `wallet:${wallet}?amount=${amount}`;
		}
	};

	useEffect(() => {
		if (payentInputs.send && payentInputs.amount) {
			const selectedWallet = wallets[0]?.wallets.find(
				(wallet) => wallet.wallet === payentInputs.send
			);

			if (selectedWallet) {
				const newQrData = generateQRData(
					selectedWallet.title.toLowerCase(),
					payentInputs.amount,
					payentInputs.send
				);
				setQrData(newQrData);
			}
		}
	}, [payentInputs.send, payentInputs.amount, wallets]);

	useEffect(() => {
		setPaymentInputs({
			...payentInputs,
			currentAmount: "",
			amount: "",
			send: "",
		});
	}, [activeMethod]);

	return (
		<div className="wrapper">
			<AlertMessage
				open={alertParams.open}
				message={alertParams.message}
				type={alertParams.type}
				onClose={handleAlertClose}
			/>
			<Drawer
				anchor="right"
				open={drawerElOpen}
				onClose={handleClose}
				sx={{
					"& .MuiDrawer-paper": {
						color: "#c2c5dd",
						width: "400px",
					},
				}}
			>
				<div className="wrapper-drawer-title">
					<p className="wrapper-drawer-title-text">Пополнить баланс</p>
					<IconButton onClick={handleClose}>
						<FontAwesomeIcon icon={faXmark} />
					</IconButton>
				</div>
				<div className="wrapper-drawer-wrapper">
					<p className="wrapper-drawer-text">Способы пополнения</p>
					<div className="wrapper-drawer-methods">
						<div
							className={
								"wrapper-drawer-methods-item " +
								(activeMethod === "crypto" ? "wrapper-drawer-methods-item-active" : "")
							}
							onClick={() => setActiveMethod("crypto")}
						>
							<div className="wrapper-drawer-methods-item-icon">
								<FontAwesomeIcon icon={faBitcoin} />
							</div>
							<p className="wrapper-drawer-methods-item-text">Криптовалюта</p>
						</div>
						<div
							className={
								"wrapper-drawer-methods-item " +
								(activeMethod === "card" ? "wrapper-drawer-methods-item-active" : "")
							}
							onClick={() => setActiveMethod("card")}
						>
							<div className="wrapper-drawer-methods-item-icon">
								<FontAwesomeIcon icon={faCreditCard} />
							</div>
							<p className="wrapper-drawer-methods-item-text">Карта</p>
						</div>
					</div>
					<p className="wrapper-drawer-text">1. Впишите нужную сумму</p>
					<TextField
						fullWidth
						id="amount"
						label="Сумма"
						variant="outlined"
						name="amount"
						slotProps={{
							input: {
								endAdornment: <InputAdornment position="end">$</InputAdornment>,
							},
						}}
						value={payentInputs.amount}
						onChange={handleChange}
					/>
					<p className="wrapper-drawer-text">
						2. Выберите {activeMethod === "crypto" ? "кошелёк" : "карту"} для оплаты
					</p>
					<FormControl fullWidth>
						<InputLabel id="currency-select-label">
							{activeMethod === "crypto" ? "Кошелёк" : "Карта"}
						</InputLabel>
						<Select
							labelId="currency-select-label"
							id="currency-select"
							name="send"
							value={payentInputs.send}
							label={activeMethod === "crypto" ? "Кошелёк" : "Карта"}
							onChange={handleChange}
						>
							<MenuItem value="">None</MenuItem>
							{activeMethod === "crypto"
								? wallets[0]?.wallets.map((wallet) => (
										<MenuItem value={wallet.wallet} key={wallet.title}>
											{wallet.title}
										</MenuItem>
								  ))
								: wallets[1]?.wallets.map((card) => (
										<MenuItem value={card.wallet} key={card.title}>
											{card.title}
										</MenuItem>
								  ))}
						</Select>
					</FormControl>

					{payentInputs.send && payentInputs.amount && activeMethod === "crypto" && (
						<>
							<p className="wrapper-drawer-text">3. Данные для оплаты</p>
							<div className="wrapper-drawer-wallet">
								<p className="wrapper-drawer-wallet-title">Адрес кошелька</p>
								<div className="wrapper-drawer-wallet-address">
									{payentInputs.send}
									<IconButton
										onClick={() => navigator.clipboard.writeText(payentInputs.send)}
										sx={{ color: "#4CAF50", fontSize: "17px" }}
									>
										<FontAwesomeIcon icon={faCopy} />
									</IconButton>
								</div>
							</div>
							<div className="wrapper-drawer-amount">
								<p className="wrapper-drawer-amount-title">Сумма</p>
								<div className="wrapper-drawer-wallet-value">
									{(payentInputs.amount / payentInputs.currentAmount).toFixed(5)}
									<IconButton
										onClick={() =>
											navigator.clipboard.writeText(
												(payentInputs.amount / payentInputs.currentAmount).toFixed(5)
											)
										}
										sx={{ color: "#4CAF50", fontSize: "17px" }}
									>
										<FontAwesomeIcon icon={faCopy} />
									</IconButton>
								</div>
							</div>
							<p
								className="wrapper-drawer-text"
								style={{ textAlign: "center", fontSize: "18px" }}
							>
								или
							</p>
							<QRCode
								value={qrData}
								size={256} // Размер QR-кода
								bgColor="transparent" // Прозрачный фон
								fgColor="#4CAF50" // Зеленый цвет элементов
								level="H" // Высокий уровень коррекции ошибок
								style={{ margin: "0 auto" }}
							/>
						</>
					)}
					{payentInputs.send && payentInputs.amount && activeMethod === "card" && (
						<>
							<p className="wrapper-drawer-text">3. Данные для оплаты</p>
							<div className="wrapper-drawer-wallet">
								<p className="wrapper-drawer-wallet-title">Номер карты</p>
								<div className="wrapper-drawer-wallet-address">
									{payentInputs.send}
									<IconButton
										onClick={() => navigator.clipboard.writeText(payentInputs.send)}
										sx={{ color: "#4CAF50", fontSize: "17px" }}
									>
										<FontAwesomeIcon icon={faCopy} />
									</IconButton>
								</div>
							</div>
							<div className="wrapper-drawer-amount">
								<p className="wrapper-drawer-amount-title">Сумма</p>
								<div className="wrapper-drawer-wallet-value">
									{payentInputs.amount * payentInputs.currentAmount}
									<IconButton
										onClick={() =>
											navigator.clipboard.writeText(
												payentInputs.amount * payentInputs.currentAmount
											)
										}
										sx={{ color: "#4CAF50", fontSize: "17px" }}
									>
										<FontAwesomeIcon icon={faCopy} />
									</IconButton>
								</div>
							</div>
						</>
					)}
				</div>
			</Drawer>
			<div className="wrapper-side">
				<div className="wrapper-side-wrapper">
					<img
						className="wrapper-side-logo"
						src="/image/side-logo.png"
						alt="wrapper-side-logo"
					/>
					<div className="wrapper-side-list">
						<NavLink to="/" className="wrapper-side-list-item">
							<div
								className={
									location.pathname === "/"
										? "wrapper-side-list-item-icon wrapper-side-list-item-icon-active"
										: "wrapper-side-list-item-icon"
								}
							>
								<img src="/icons/trade.svg" alt="home-icon" />
							</div>
							<span className="wrapper-side-list-item-title">Торговля</span>
						</NavLink>
						<NavLink to="/profile" className="wrapper-side-list-item">
							<div
								className={
									location.pathname === "/profile"
										? "wrapper-side-list-item-icon wrapper-side-list-item-icon-active"
										: "wrapper-side-list-item-icon"
								}
							>
								<img src="/icons/profile.svg" alt="profile-icon" />
							</div>
							<span className="wrapper-side-list-item-title"> Профиль</span>
						</NavLink>
						<NavLink to="/accounts" className="wrapper-side-list-item">
							<div
								className={
									location.pathname === "/accounts"
										? "wrapper-side-list-item-icon wrapper-side-list-item-icon-active"
										: "wrapper-side-list-item-icon"
								}
							>
								<img src="/icons/wallet.svg" alt="wallet-icon" />
							</div>
							<span className="wrapper-side-list-item-title">Аккаунты</span>
						</NavLink>
						<NavLink to="/savings" className="wrapper-side-list-item">
							<div
								className={
									location.pathname === "/savings"
										? "wrapper-side-list-item-icon wrapper-side-list-item-icon-active"
										: "wrapper-side-list-item-icon"
								}
							>
								<img src="/icons/percent.svg" alt="percent-icon" />
							</div>
							<span className="wrapper-side-list-item-title">Сбережения</span>
						</NavLink>
						{user.role === "admin" && (
							<NavLink to="/admin" className="wrapper-side-list-item">
								<div
									className={
										location.pathname === "/admin"
											? "wrapper-side-list-item-icon wrapper-side-list-item-icon-active"
											: "wrapper-side-list-item-icon"
									}
								>
									<FontAwesomeIcon icon={faUserTie} />
								</div>
								<span className="wrapper-side-list-item-title">Админка</span>
							</NavLink>
						)}
					</div>
				</div>
				<div className="wrapper-side-footer">
					<div className="wrapper-side-list-item" onClick={handleLogout}>
						<div className="wrapper-side-list-item-icon">
							<img src="/icons/logout.svg" alt="logout-icon" />
						</div>
						<span className="wrapper-side-list-item-title">Выход</span>
					</div>
				</div>
			</div>
			<div className="wrapper-main">
				<div className="wrapper-main-header">
					<Button
						variant="contained"
						sx={{
							color: "#b7c4ff",
							backgroundColor: "#262c42",
							borderRadius: "100px",
							padding: "8px 15px ",
							fontSize: "16px",
							textTransform: "capitalize",
							display: "flex",
							alignItems: "center",
							letterSpacing: "0.15px",
							gap: "8px",
							lineHeight: "24px",
							fontWeight: "400",
							height: "38px",
						}}
						onClick={handleDrawerOpen}
					>
						<img src="/icons/dep.svg" alt="deposit-icon" style={{ width: "20px" }} />
						Пополнить
					</Button>
					<div className="wrapper-main-header-item">
						<Button
							variant="contained"
							sx={{
								color: "#c2c5dd",
								backgroundColor: "#262c42",
								borderRadius: "100px",
								padding: "8px 15px ",
								fontSize: "11px",
								textTransform: "capitalize",
								display: "flex",
								alignItems: "center",
								letterSpacing: "0.5px",
								gap: "8px",
								lineHeight: "16px",
								fontWeight: "400",
								height: "38px",
							}}
							aria-controls={open ? "basic-menu" : undefined}
							aria-haspopup="true"
							aria-expanded={open ? "true" : undefined}
							onClick={handleClick}
						>
							<FontAwesomeIcon icon={faWallet} style={{ fontSize: "16px" }} />
							Standard Аккаунт USD
							<FontAwesomeIcon icon={faAngleDown} />
						</Button>
						<Menu
							id="demo-positioned-menu"
							aria-labelledby="demo-positioned-button"
							anchorEl={anchorEl}
							open={open}
							onClose={handleClose}
							anchorOrigin={{
								vertical: "bottom",
								horizontal: "center",
							}}
							transformOrigin={{
								vertical: "top",
								horizontal: "center",
							}}
							sx={{
								"& .MuiPaper-root": {
									backgroundColor: "#1b2033",
									color: "#c2c5dd",
									borderRadius: "8px",
									fontSize: "14px",
									fontWeight: "400",
									lineHeight: "20px",
									mt: "12px",
									width: "400px",
									border: "1px solid #292f47",
								},
							}}
						>
							<MenuItem sx={{ justifyContent: "center" }}>Выбранный Аккаунт</MenuItem>
							<Divider sx={{ borderColor: "#292f47" }} />
							<div className="wrapper-main-header-item-account-wrapper">
								<div className="wrapper-main-header-item-account">
									<div className="wrapper-main-header-item-account-title">
										<div className="wrapper-main-header-item-account-title-info">
											<img src="/icons/usa.svg" alt="usa-icon" />
											<span>Standard Аккаунт USD</span>
											<IconButton
												variant="contained"
												sx={{ fontSize: "14px", color: "#c2c5dd" }}
											>
												<FontAwesomeIcon icon={faArrowUpRightFromSquare} />
											</IconButton>
										</div>
										<div class="checkbox-wrapper-15">
											<input
												class="inp-cbx"
												id="cbx-15"
												type="checkbox"
												style={{ display: "none" }}
												checked
											/>
											<label class="cbx" htmlFor="cbx-15">
												<span>
													<svg width="12px" height="9px" viewBox="0 0 12 9">
														<polyline points="1 5 4 8 11 1"></polyline>
													</svg>
												</span>
											</label>
										</div>
									</div>
									<div className="wrapper-main-header-item-account-main">
										<div className="wrapper-main-header-item-account-main-actions">
											<div className="wrapper-main-header-item-account-main-actions-balance">
												$ {user.balance}
											</div>
											<Stack direction="row" spacing={1}>
												<Button
													variant="contained"
													sx={{
														color: "#b7c4ff",
														backgroundColor: "#262c42",
														borderRadius: "100px",
														padding: "8px 15px ",
														fontSize: "16px",
														textTransform: "capitalize",
														display: "flex",
														alignItems: "center",
														letterSpacing: "0.15px",
														gap: "8px",
														lineHeight: "24px",
														fontWeight: "400",
														height: "38px",
													}}
													onClick={handleDrawerOpen}
												>
													<img
														src="/icons/dep.svg"
														alt="deposit-icon"
														style={{ width: "20px" }}
													/>
													Пополнить
												</Button>
												<IconButton
													variant="contained"
													sx={{
														backgroundColor: "#262c42",
														fontSize: "16px",
														width: "38px",
														height: "38px",
														color: "#b7c4ff",
													}}
													onClick={() =>
														setAlertParams({
															open: true,
															type: "error",
															message: "Недостаточно средств для перевода",
														})
													}
												>
													<FontAwesomeIcon icon={faPaperPlane} />
												</IconButton>
											</Stack>
										</div>
										<div className="wrapper-main-header-item-account-main-info">
											<div className="wrapper-main-header-item-account-main-info-item">
												<div className="wrapper-main-header-item-account-main-info-item-title">
													Кредит
												</div>
												<div className="wrapper-main-header-item-account-main-info-item-value">
													$ 0
												</div>
											</div>
											<div className="wrapper-main-header-item-account-main-info-item">
												<div className="wrapper-main-header-item-account-main-info-item-title">
													Капитал
												</div>
												<div className="wrapper-main-header-item-account-main-info-item-value">
													$ 0
												</div>
											</div>
											<div className="wrapper-main-header-item-account-main-info-item">
												<div className="wrapper-main-header-item-account-main-info-item-title">
													PNL
												</div>
												<div className="wrapper-main-header-item-account-main-info-item-value">
													$ {user.pnl}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</Menu>
						<div className="wrapper-main-header-item-balance">$ {user.balance}</div>
						<Divider
							orientation="vertical"
							variant="middle"
							flexItem
							sx={{ borderColor: "#292f47", height: "24px" }}
						/>
						<div className="wrapper-main-header-item-subitem">
							<div className="wrapper-main-header-item-subitem-title">Кредит</div>
							<div className="wrapper-main-header-item-subitem-value">$ 0</div>
						</div>
						<div className="wrapper-main-header-item-subitem">
							<div className="wrapper-main-header-item-subitem-title">Капитал</div>
							<div className="wrapper-main-header-item-subitem-value">$ 0</div>
						</div>
						<div className="wrapper-main-header-item-subitem">
							<div className="wrapper-main-header-item-subitem-title">PNL</div>
							<div className="wrapper-main-header-item-subitem-value">
								$ {user.pnl}
							</div>
						</div>
					</div>
					<div className="wrapper-main-header-profile" onClick={handleClick2}>
						<span className="wrapper-main-header-profile-name">{`${user.name} ${user.surname}`}</span>
						<Avatar
							sx={{
								width: 40,
								height: 40,
								fontSize: "16px",
								backgroundColor: "#b7c4ff",
							}}
						>
							{`${user.name && user.name[0]}${user.surname && user.surname[0]}`}
						</Avatar>
					</div>
					<Menu
						id="account-positioned-menu"
						aria-labelledby="account-positioned-button"
						anchorEl={anchorEl2}
						open={open2}
						onClose={handleClose}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "center",
						}}
						transformOrigin={{
							vertical: "top",
							horizontal: "center",
						}}
						sx={{
							"& .MuiPaper-root": {
								backgroundColor: "#1b2033",
								color: "#c2c5dd",
								borderRadius: "8px",
								fontSize: "14px",
								fontWeight: "400",
								lineHeight: "20px",
								mt: "12px",
								width: "400px",
								border: "1px solid #292f47",
							},
						}}
					>
						<div className="wrapper-header-profile">
							<div className="wrapper-header-profile-info">
								<Avatar
									sx={{
										width: 40,
										height: 40,
										fontSize: "16px",
										backgroundColor: "#b7c4ff",
									}}
								>
									{`${user.name && user.name[0]}${user.surname && user.surname[0]}`}
								</Avatar>
								<div className="wrapper-header-profile-info-text">
									<p className="wrapper-header-profile-info-text-name">{`${user.name} ${user.surname}`}</p>
									<p className="wrapper-header-profile-info-text-email">{user.email}</p>
								</div>
								<NavLink
									to="/profile"
									onClick={handleClose}
									className="wrapper-header-profile-info-actions"
								>
									<IconButton
										variant="contained"
										sx={{
											fontSize: "14px",
											color: "#c2c5dd",
											display: "flex",
											gap: "8px",
											borderRadius: "6px",
										}}
									>
										<FontAwesomeIcon icon={faArrowUpRightFromSquare} />
										Профиль
									</IconButton>
								</NavLink>
							</div>
						</div>
					</Menu>
				</div>
				<div className="wrapper-main-content">
					{<Outlet context={{ handleDrawerOpen, user }} />}
				</div>
				<div className="wrapper-main-footer">
					<div className="wrapper-main-footer-copyright">
						<p>© Cscalp {new Date().getFullYear()}</p>
						<p>support@cs-calp.com</p>
					</div>
					<div className="wrapper-main-footer-info">
						<div className="wrapper-main-footer-info-item">
							<div className="wrapper-main-footer-info-item-title">Баланс</div>
							<div className="wrapper-main-footer-info-item-value">
								$ {user.balance}
							</div>
						</div>
						<div className="wrapper-main-footer-info-item">
							<div className="wrapper-main-footer-info-item-title">Кредит</div>
							<div className="wrapper-main-footer-info-item-value">$ 0</div>
						</div>
						<div className="wrapper-main-footer-info-item">
							<div className="wrapper-main-footer-info-item-title">Капитал</div>
							<div className="wrapper-main-footer-info-item-value">
								$ {user.balance}
							</div>
						</div>
						<div className="wrapper-main-footer-info-item">
							<div className="wrapper-main-footer-info-item-title">Маржа</div>
							<div className="wrapper-main-footer-info-item-value">$ 0</div>
						</div>
						<div className="wrapper-main-footer-info-item">
							<div className="wrapper-main-footer-info-item-title">Уровень маржи</div>
							<div className="wrapper-main-footer-info-item-value">0 %</div>
						</div>
						<div className="wrapper-main-footer-info-item">
							<div className="wrapper-main-footer-info-item-title">
								Свободная маржа
							</div>
							<div className="wrapper-main-footer-info-item-value">$ 0</div>
						</div>
						<div className="wrapper-main-footer-info-item">
							<div className="wrapper-main-footer-info-item-title">PNL</div>
							<div className="wrapper-main-footer-info-item-value">$ {user.pnl}</div>
						</div>
					</div>
					<div className="wrapper-main-footer-chat">
						<FontAwesomeIcon icon={faComments} />
						<p className="wrapper-main-footer-chat-title">Live чат</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Wrapper;
